/**
 * @file features/scheduleReminders/syncSignal.ts
 * @brief "Sync the desktop's alarms and calendar now", from anywhere, without
 *        importing the sync (scheduledMeetingsApi ↔ desktopScheduleSync would
 *        be a cycle). DesktopScheduleBridge listens. A no-op in a browser tab.
 *
 * @author DES
 * @date 09-10-2026
 */

const EVENT = "vz:schedule-sync";

/** After scheduling, editing or cancelling here, or connecting the calendar. */
export function requestScheduleSync() {
  window.dispatchEvent(new Event(EVENT));
}

export function onScheduleSyncRequest(cb: () => void): () => void {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
}
